module.exports = __webpack_public_path__ + "static/media/SarahSwitek_04_BodySensations_13.b0ceb6d2.mp3";